import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { DataProviderInstance } from '../../../api/DataProvider';
import { formatDate } from '../../../utils/Utils';
import ConfirmPopup from '../../../popup/ConfirmPopup/ConfirmPopup';
import { SourceChip } from '../shared/SourceAvatar';
import RowAction from '../shared/RowAction';
import shared from '../shared/MarketingShared.module.css';
import styles from './Campaigns.module.css';

// `onBlockedAction`: quando informado (plano sem marketing), excluir abre o
// modal de upgrade em vez de chamar a API.
const CampaignRow = ({ campaignData, onEdit, onUpdate, onBlockedAction = null }) => {
  const { CompanyConfig, DeleteCampaign } = DataProviderInstance();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  // Erro do servidor ao excluir (ex.: campanha com leads): aparece no mesmo popup, no lugar do alert()
  const [deleteError, setDeleteError] = useState('');

  const { id, name, sourceId, defaultMessage, description, createdAt, updatedAt } = campaignData;

  const source = CompanyConfig.LeadsSources.find(
    (x) => x.id == sourceId
  ) || { name: "Desconhecida" };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onBlockedAction) { onBlockedAction(); return; }
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    DeleteCampaign(id, (response) => {
      if (response.status == "success") {
        onUpdate();
      } else {
        setDeleteError(response.message || response.error || "Não foi possível excluir a campanha.");
        setShowDeleteConfirm(true);
      }
    });
    setShowDeleteConfirm(false);
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setDeleteError('');
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(campaignData);
  };

  const formattedCreatedAt = createdAt ? formatDate(new Date(createdAt)) : '';
  const formattedUpdatedAt = updatedAt ? formatDate(new Date(updatedAt)) : '';
  const dateTitle = formattedUpdatedAt ? `Atualizada em ${formattedUpdatedAt}` : '';

  return (
    <li className={`${shared.row} ${styles.row}`}>
      <span className={`${shared.avatar} ${shared.tone_neutral}`} aria-hidden="true">
        <CampaignOutlinedIcon style={{ fontSize: 20 }} />
      </span>

      <div className={shared.identity}>
        <span className={shared.name}>{name}</span>
        <span className={`${shared.subtext} ${description ? '' : styles.noDescription}`}>
          {description || "Sem descrição"}
        </span>
      </div>

      <span className={styles.sourceCell}>
        <SourceChip name={source.name} />
      </span>

      <span className={styles.messageCell}>
        {defaultMessage ? (
          <Tooltip title={defaultMessage} arrow placement="top">
            <span className={styles.message}>
              <ChatBubbleOutlineRoundedIcon className={styles.messageIcon} />
              <span className={styles.messageText}>{defaultMessage}</span>
            </span>
          </Tooltip>
        ) : (
          <span className={styles.noMessage}>Sem mensagem padrão</span>
        )}
      </span>

      <Tooltip title={dateTitle} arrow>
        <span className={shared.date}>
          {formattedCreatedAt && (
            <>
              <EventOutlinedIcon className={shared.dateIcon} />
              Criada em {formattedCreatedAt}
            </>
          )}
        </span>
      </Tooltip>

      <span className={shared.actions}>
        <RowAction title="Editar" onClick={handleEdit}>
          <EditOutlinedIcon style={{ fontSize: 17 }} />
        </RowAction>
        <RowAction title="Excluir" tone="danger" onClick={handleDelete}>
          <DeleteOutlineRoundedIcon style={{ fontSize: 18 }} />
        </RowAction>
      </span>

      {showDeleteConfirm && (
        <ConfirmPopup
          Visibility={showDeleteConfirm}
          Title={deleteError ? "Não foi possível excluir" : "Excluir Campanha"}
          Description={deleteError || `Tem certeza que deseja excluir a campanha "${name}"?`}
          ConfirmLabel={deleteError ? "Entendi" : "Excluir"}
          OnConfirm={deleteError ? () => {} : confirmDelete}
          OnCancel={cancelDelete}
          OnHide={cancelDelete}
        />
      )}
    </li>
  );
};

export default CampaignRow;
